var vskoInputGroup = angular.module('vskoInputGroup', []);

vskoInputGroup.directive('vskoInputGroup', function() {
  return {
    restrict: 'E',
    template: require('./vsko-input-group.html'),
    transclude: {
      inputSlot: 'vskoInput',
      prefixSlot: '?vskoInputGroupPrefix',
      suffixSlot: '?vskoInputGroupSuffix'
    },
    scope: {},
    link: function($scope, element, attrs) {
      $scope.hasPrefix = element.find('vsko-input-group-prefix')[0] != undefined;
      $scope.hasSuffix = element.find('vsko-input-group-suffix')[0] != undefined;
    }
  }
});

vskoInputGroup.directive('vskoInputGroupPrefix', function() {
  return {
    restrict: 'E'
  }
});

vskoInputGroup.directive('vskoInputGroupSuffix', function() {
  return {
    restrict: 'E'
  }
});
